module.exports = __webpack_public_path__ + "media/partners/nestle-e501de26.svg";